class AuthStore {
  token = null

  kwAuthToken = null
}

export default new AuthStore()
